import { DateNewTag } from 'component/candy/DateNewTag/DateNewTag';
import { IsLoadingSpinner } from 'component/candy/IsLoadingSpinner/IsLoadingSpinner';
import { RecentlyUpdatedTag } from 'component/candy/RecentlyUpdatedTag/RecentlyUpdatedTag';

/**
 * Shows various tags and spinners that are used to indicate the state of the Vulnerability.
 */

export const TitleCandyCluster = ({
  isLoading,
  latestRevisionDate,
  releaseDate,
  revisionLength,
}: {
  isLoading: boolean;
  latestRevisionDate: Date | string | undefined;
  releaseDate: Date | string | undefined;
  /**
   * The number of revisions this item has.
   */
  revisionLength: number;
}) => {
  return (
    <>
      {' '}
      <DateNewTag date={releaseDate} />
      <RecentlyUpdatedTag
        date={latestRevisionDate}
        revisionLength={revisionLength}
      />
      <IsLoadingSpinner
        isLoading={isLoading}
        style={{ display: 'inline-block' }}
      />
    </>
  );
};
